import React, { useState, useContext } from "react";

import { ContextSolicitacoes } from "../../../services/solicitacoes";

import { ContextNotificacoes } from "../../../services/notificacoes";

import { Spinner } from "../../StyledComponent";

import { ReactComponent as History } from "../../../assets/novosicones/notificacoes/agendamentos.svg";

import { useHistory } from "react-router-dom";

import Fases from "../Fases";

import VistoriaNaoCompareceu from "./VistoriaNaoCompareceu";

const Agendamentos = ({ tema, setNotificationsModal }) => {
  const [loading, setLoading] = useState(false);

  const [agendamentoSelecionado, setAgendamentoSelecionado] = useState("");

  const { getSolicitacao } = useContext(ContextSolicitacoes);

  const {
    marcarNotificacaoAgendamento,
    setNotificationNotFoundError,
    atualizaNotificacoes,
  } = useContext(ContextNotificacoes);

  const NOTIFICATIONSAGENDAMENTOS = JSON.parse(
    sessionStorage.getItem("agendamentos")
  );

  const NOTIFICATIONSFASES = JSON.parse(
    sessionStorage.getItem("notificationsFase")
  );

  const NOTIFICATIONSVISTORIANAOCOMPARECEU = JSON.parse(
    sessionStorage.getItem("notificationsVistoriaNaoCompareceu")
  );

  const history = useHistory();

  const updateNotificacoes = (id) => {
    let temp = NOTIFICATIONSAGENDAMENTOS.filter(
      (agendamento) => agendamento.Id != id
    );
    sessionStorage.setItem("agendamentos", JSON.stringify(temp));
  };

  async function redirectToSolicitations(id) {
    setLoading(true);

    await marcarNotificacaoAgendamento(id);
    await atualizaNotificacoes();
    let resultGet = await getSolicitacao(id);
    updateNotificacoes(id);
    if (resultGet?.status === 400) {
      setNotificationNotFoundError(true);
      setLoading(false);
      setNotificationsModal(false);
    } else {
      history.push({
        pathname: "/solicitacoes/acompanhar-solicitacao",
        state: {
          solicitacao: resultGet,
        },
      });
      setLoading(false);
      setNotificationsModal(false);
    }
  }

  function checkTurno(date) {
    var dataCompromisso = new Date(date);

    if (dataCompromisso.getUTCHours() >= 12) return "Tarde";
    else return "Manhã";
  }

  function getHours(date) {
    var dataCompromisso = new Date(date);

    return (
      (dataCompromisso.getUTCHours() < 10
        ? "0" + dataCompromisso.getUTCHours()
        : dataCompromisso.getUTCHours()) +
      ":" +
      ((dataCompromisso.getUTCMinutes() < 10 ? "0" : "") +
        dataCompromisso.getUTCMinutes())
    );
  }

  function formatDateForNotification(date) {
    return date.split("T")[0].split("-").reverse().join("/");
  }

  if (
    !NOTIFICATIONSAGENDAMENTOS.length &&
    !NOTIFICATIONSFASES.length &&
    !NOTIFICATIONSVISTORIANAOCOMPARECEU.length
  )
    return null;

  return (
    <div className="notifications__item">
      <span
        className="notifications__item__title"
        style={{ color: tema.primaryColor }}
      >
        Solicitações e Agendamentos:
      </span>

      {NOTIFICATIONSAGENDAMENTOS?.length > 0 &&
        NOTIFICATIONSAGENDAMENTOS.map((notification, index) => {
          return (
            <div key={index} className="centralized-space-between">
              <div className="centralized">
                <span
                  style={{ width: "24px", height: "24px", display: "block" }}
                >
                  <History
                    style={
                      notification?.Visualizado
                        ? { fill: "#D1D1D1" }
                        : { fill: tema.primaryColor }
                    }
                  />
                </span>
                {notification.Subgrupo == "AT_INCORPORACAO" && (
                  <p
                    className="notifications__item__description"
                    style={
                      notification?.Visualizado
                        ? { fill: "#D1D1D1" }
                        : { fill: tema.primaryColor }
                    }
                  >
                    A assistência técnica na unidade {notification?.Ativo} está
                    agendada para dia{" "}
                    <b>
                      {" "}
                      {formatDateForNotification(
                        notification.CompromissoServico?.SchedStartTime
                      )}{" "}
                      no turno da{" "}
                      {checkTurno(
                        notification.CompromissoServico?.SchedStartTime
                      )}
                    </b>
                    . Um maior de 18 anos deverá aguardar para nos receber.
                  </p>
                )}
                {notification.Subgrupo == "ENTREGA_UNIDADE" && (
                  <p
                    className="notifications__item__description"
                    style={
                      notification?.Visualizado
                        ? { fill: "#D1D1D1" }
                        : { fill: tema.primaryColor }
                    }
                  >
                    Lembrando: Sua entrega da unidade {notification?.Ativo} está
                    agendada para dia{" "}
                    <b>
                      {formatDateForNotification(
                        notification.CompromissoServico?.SchedStartTime
                      )}{" "}
                      às{" "}
                      {getHours(notification.CompromissoServico?.SchedStartTime)}
                      h
                    </b>
                    . Estaremos te esperando!
                  </p>
                )}
                {notification.Subgrupo == "VISTORIA" && (
                  <p
                    className="notifications__item__description"
                    style={
                      notification?.Visualizado
                        ? { fill: "#D1D1D1" }
                        : { fill: tema.primaryColor }
                    }
                  >
                    Lembrando: Sua vistoria na unidade {notification?.Ativo}{" "}
                    está agendada para dia{" "}
                    <b>
                      {formatDateForNotification(
                        notification.CompromissoServico?.SchedStartTime
                      )}{" "}
                      às{" "}
                      {getHours(
                        notification.CompromissoServico?.SchedStartTime
                      )}
                      h
                    </b>
                    . Estaremos te esperando!
                  </p>
                )}
              </div>
              {loading && agendamentoSelecionado == notification.Id ? (
                <Spinner />
              ) : (
                <a
                  style={{ color: tema.primaryColor, cursor: "pointer" }}
                  onClick={() => {
                    setAgendamentoSelecionado(notification.Id);
                    redirectToSolicitations(notification.Id);
                  }}
                >
                  VISUALIZAR
                </a>
              )}
            </div>
          );
        })}
      <Fases tema={tema} setNotificationsModal={setNotificationsModal} />
      <VistoriaNaoCompareceu
        tema={tema}
        setNotificationsModal={setNotificationsModal}
      />
    </div>
  );
};

export default Agendamentos;
